@if (useShellLayout()) {
  <router-outlet />
  <app-footer2 />
} @else {
  <section
    class="flex h-screen w-full items-center bg-[url(/assets/images/auth-bg.jpg)] bg-cover bg-right-bottom bg-no-repeat p-6">
    <div class="absolute inset-0 h-full w-full bg-black/60"></div>

    <div class="container relative z-10">
      <div class="mx-auto max-w-5xl overflow-hidden rounded-lg bg-black/40 backdrop-blur-2xl">
        <router-outlet />
      </div>
    </div>
  </section>

  <app-footer2 />
}
